import { List, ListItem } from "@mui/material";
import { Weight } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";

export default function WeightRestrictions(props: IRoutePartProps) {

    return (    
        <>
            {props.roadFeatures && props.roadFeatures.weights && props.roadFeatures.weights.length > 0 &&
            <List style={{paddingTop: "0px", paddingBottom:"0px"}}>
                {props.roadFeatures.weights.map( (weightRestriction: Weight, index: number) => (
                    <ListItem 
                    style={{paddingTop: "0px", paddingBottom:"0px", color:"gray"}} 
                    key={weightRestriction.maxWeight + index} 
                    className="roadFeature" 
                    onClick={(event) => {props.onClick(weightRestriction, event)}}
                    onMouseEnter={() => props.onMouseEnterItem(weightRestriction)}
                    onMouseLeave={props.onMouseLeaveItem}>
                        Maksvekt: {weightRestriction.maxWeight} tonn
                    </ListItem>
                ))}
            </List>
            }
        </>            
    )

}